
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 4a2 2 0 012 2v12a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2zm.983 1.818l-7.661 5.892a3.808 3.808 0 01-4.47.126l-.174-.126-7.661-5.892C2.006 5.877 2 5.938 2 6v12a1 1 0 001 1h18a1 1 0 001-1V6c0-.062-.006-.123-.017-.182zM21 5H3a.998.998 0 00-.332.057l7.62 5.86a2.808 2.808 0 003.262.117l.162-.116 7.62-5.861A.998.998 0 0021 5z","fill":"#373534","fill-rule":"evenodd"}})])
          )
        }
      }
    